export default __webpack_public_path__ + "assets/upload_logo_brand.26df02.png";